import React from "react";
import { Link } from "react-router-dom";
import backimg from '../../../assets/solutions-images/hero_ban_integration_hub.webp';
import "../solution.css"
const IntegrationHub = () => {
    return (
        <>
            <div>
                <div
                    className="bg-cover bg-center bg-no-repeat min-h-[502px] flex flex-col gap-8 justify-center px-6 py-16 md:px-8 lg:px-16 hover_herosec"
                    style={{ backgroundImage: `url(${backimg})` }}
                >
                    <h1 style={{ wordSpacing: '8px' }} data-aos="fade-down" className="text-xl md:text-3xl lg:text-5xl font-semibold text-white w-full sm:w-full md:w-2/3 lg:w-2/4">
                        Simplify Complex Integration Processes
                    </h1>
                    <p className="text-white text-sm max-w-[620px]" data-aos="fade-down">
                        Tekpossible is your trusted partner for enhancing productivity through optimized ServiceNow Integration Hub solutions. With our expertise, we help you deploy tools designed to streamline workflows, minimize repetitive tasks, and reduce friction across the integration process. This ensures seamless connectivity with your critical business systems, empowering your organization to operate more efficiently.
                    </p>
                    <Link
                        data-aos="zoom-in"
                        data-aos-delay="200"
                        to="/contact-us"
                        className="w-[100px] w-fit sm:w-[150px] md:w-[140px] text-semibold lg:w-[150px] bg-[#C32A7C] px-5 py-2 sm:px-6 sm:py-2.5 lg:px-7 lg:py-2 rounded-lg text-white  hover:bg-white hover:text-[#C32A7C] transition-colors duration-400 ease-in-out text-sm sm:text-sm md:text-sm lg:text-lg text-center whitespace-nowrap"
                    >
                        Contact Us
                    </Link>

                </div>
            </div>
            <div className="bg-[#FFFFFF] mt-6">

                <div className="flex flex-col sm:justify-center text-center items-center gap-4 py-8 px-4">
                    <h1 className="text-[#1A5298] font-bold text-lg md:text-3xl max-w-[970px]">
                        How can Integration Hub solutions by ServiceNow assist you in reaching your goals?
                    </h1>
                </div>

                <div className="bg-white mb-10">
                    <div data-aos="zoom-in-down" className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-10 px-4 md:px-10 lg:px-10 py-5 items-start">
                        <div className="flex flex-col items-center w-2/1 text-center justify-center lined_hoverset">
                            <h2 className="text-[#000] text-base lg:text-[15px] xl:text-xl font-semibold max-w-[250px] text-center">Automate the Integration Process</h2>
                            <div className="mt-2 flex flex-col items-center md:w-40">
                                <img
                                    className="object-contain my-5"
                                    src={require("../../../assets/solutions-images/line_gapers.svg").default}
                                    alt="Enhance IT Workflows"
                                />
                            </div>
                            <p className="text-black text-center max-w-[515px]">
                                Effortlessly automate integrations or tailor your processes using prebuilt flows and actions. This allows you to seamlessly connect ServiceNow workflows with third-party business systems in just minutes.
                            </p>
                        </div>
                        <div className="flex flex-col items-center w-2/1 text-center justify-center lined_hoverset">
                            <h2 className="text-[#000] text-base lg:text-[15px] xl:text-xl font-semibold max-w-[200px] text-center">Reduce Developer Burden</h2>
                            <div className="mt-2 flex flex-col items-center md:w-40 ">
                                <img
                                    className="object-contain my-5"
                                    src={require("../../../assets/solutions-images/line_gapers.svg").default}
                                    alt="Enhance IT Workflows"
                                />
                            </div>
                            <p className="text-black text-center max-w-[515px]">
                                Enhance productivity by utilizing reusable spokes, which guide developers to seamlessly integrate with external systems through custom actions within the Action Designer interface.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            <div className="bg-[#F4F4F4] w-full py-10 md:py-12">
                <div className="flex flex-col items-center text-center px-4 md:px-6" data-aos="zoom-in-down">

                    <h1 className="text-[#1A5298] font-bold text-xl md:text-2xl lg:text-4xl text-center mb-5 w-full">
                        Our ServiceNow Integration Hub Expertise
                    </h1>
                    <h5 className="text-md text-black font-medium text-center w-2/3">Integration Steps | Pre-Built Spokes</h5>

                </div>
            </div>
            <div className="bg-[#FFFFFF] w-full py-10 md:py-12">
                <div className="flex flex-col items-center text-center px-4 md:px-6">

                    <h1 data-aos="zoom-in-down" className="line_heightsests text-[#1A5298] font-bold text-xl md:text-2xl lg:text-4xl text-center mb-8 w-full md:w-2/2 lg:w-2/3">
                        Create the foundation for smooth integration and effortlessly connect your essential business systems.
                    </h1>
                    <Link
                        data-aos="zoom-in"
                        data-aos-delay="200"
                        to={"/contact-us"}
                        className="w-[140px] px-6 py-2 md:px-4 md:py-2.5 bg-[#C32A7C] rounded-lg text-white font-semibold 
                        hover:bg-[#F6F6F6] hover:text-[#C32A7C] transition-colors duration-300 text-sm md:text-base 
                        text-center whitespace-nowrap mt-4 border border-[#C32A7C]"
                    >
                        Contact Us
                    </Link>

                </div>
            </div>
        </>
    );
}

export default IntegrationHub;